import * as React from 'react';
import Button from '../../../../components/Button';
import CardCarousel from '../../../../components/CardCarousel';

import './style.scss';

const CaseStudiesSection = () => {
  return (
    <section className="l-case-studies-section">
      <div className="container">
        <h2 className="section-title">Case Studies</h2>
        <CardCarousel>
          <div className="card">
            <div className="title">Law Institute of Victoria governance review</div>
            <div className="content">
              Following a governance review, the Law Institute of Victoria (LIV) adopted changes to its constitution and
              governance in April 2022. The review process involved extensive consultation with LIV members, and the
              approach and outcomes demonstrate a commitment to evolving governance arrangements.
            </div>
            <Button
              color="primary"
              label="Read case study"
              icon="link"
              annualReportPage={38}
              onClick={() => window.gtag('event', 'Read case study 1')}
            />
          </div>

          <div className="card">
            <div className="title">An independent report into the benefits of professional standards schemes</div>
            <div className="content">
              The Councils continued to deliver on a key strategic initiative from Strategy 2021 to “build an evidence
              base to demonstrate effectiveness”. This included the publication of an independent report, ‘The benefits
              of professional standards schemes – limitation of liability and consumer protection measures’, by Taylor
              Fry actuaries. This aims to help associations to realise the full range of benefits in operating schemes
              for their members and their clients.
            </div>
            <Button
              color="primary"
              label="Read case study"
              icon="link"
              annualReportPage={62}
              onClick={() => window.gtag('event', 'Read case study 2')}
            />
          </div>

          <div className="card">
            <div className="title">
              Innovative ways of changing culture in response to sexual harassment risks in the legal profession
            </div>
            <div className="content">
              Sexual harassment has been identified as a prevalent issue in the workplaces of the legal profession,
              making it a significant risk to professional standards. The Councils, regulated associations and legal
              services regulators have taken, and continue to take, targeted actions in response.
            </div>
            <Button
              color="primary"
              label="Read case study"
              icon="link"
              annualReportPage={68}
              onClick={() => window.gtag('event', 'Read case study 3')}
            />
          </div>

          <div className="card">
            <div className="title">Improving compliance monitoring and risk management</div>
            <div className="content">
              The Institute of Public Accountants launched a new Quality Review Program to assess member compliance with
              professional and ethical standards, and to assist non-compliant members in achieving compliant status.
            </div>
            <Button
              color="primary"
              label="Read case study"
              icon="link"
              annualReportPage={51}
              onClick={() => window.gtag('event', 'Read case study 4')}
            />
          </div>
        </CardCarousel>
      </div>
    </section>
  );
};

export default CaseStudiesSection;
